<template>
  <div
    class="sn-bs-wrapper"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <main
      v-if="!!farmDesc || farmImageList.length != 0"
      class="sn-bs-wrapper__main"
    >
      <div class="sn-bs-wrapper-title">
        {{ farmDesc }}
      </div>
      <div class="sn-bs-wrapper-imgs">
        <img
          class="sn-bs-wrapper-imgs__img"
          v-for="(item, index) in farmImageList"
          @click="lookImg(index)"
          :key="index"
          :src="setImgUrl(item, 88, 88)"
          alt=""
        />
      </div>
    </main>
    <Empty v-else-if="!loading" />

    <BsPreviewPic
      :initial-index="index"
      :showDialog="showDialog"
      :imgUrlData="farmImageList"
      @closeDialog="showDialog = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { farm } from "@/api/request/snkd.produce";
import Empty from "@/components/bs/BsBoxPanel/Empty";
import { setImgUrl } from "@/utils";
import BsPreviewPic from "@/components/bs/BsPreviewPic";

export default {
  name: "FarmIntroduction",
  components: { Empty, BsPreviewPic },
  data() {
    return {
      loading: false,
      farmDesc: "", // 农场介绍
      farmImageList: [], // 环境照片

      showDialog: false,
      index: 0,
    };
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },
  mounted() {
    this.initModel();
  },
  methods: {
    setImgUrl,
    async initModel() {
      this.loading = true;
      try {
        const { farmDetailVO } = await farm.getService({
          companyId: this.companyId,
          farmId: this.farmId,
        });
        this.farmDesc = farmDetailVO.farmDesc;
        this.farmImageList = farmDetailVO.farmImageList;
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },

    lookImg(index) {
      this.$emit("closeAll"); //触发父级事件 关闭当前页面所有弹框
      this.index = index;
      this.showDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@include bs(wrapper) {
  @include utils-full-box();
  padding-left: 10px;
  box-sizing: border-box;

  @include e(main) {
    @include utils-full-box();
    display: flex;
    flex-direction: column;

    @include bs(wrapper-title) {
      @include utils-scrollbar();
      width: 100%;
      //height: calc(100% - 100px);
      margin: 12px 0;
      overflow-y: scroll;
      color: #9dd1d7;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
    }

    @include bs(wrapper-imgs) {
      @include utils-scrollbar();
      width: 100%;
      min-height: 94px;
      display: flex;
      overflow-x: auto;

      @include e(img) {
        width: 88px;
        height: 88px;
        margin-right: 10px;
        cursor: pointer;
        background: #0a3927;
      }
    }
  }
}
</style>
